import React from 'react'

import ErrorPage from './errorPage'

export default ({ popularFilesUrl, siteDisplayName }) => (
  <ErrorPage title={'Search is unavailable'}>
    <p className="fds-c-text-body -size-xl">
      ...but don&apos;t worry, you can still discover.
      <br />
      We are working hard to fix this. Meanwhile you can
      <br />
      <br />
      - Browse{' '}
      <a className="fds-c-text-link -decoration-none" href={popularFilesUrl}>
        popular files
      </a>{' '}
      in {siteDisplayName}
      <br />
      -{' '}
      <a
        className="fds-c-text-link -decoration-none"
        href="javascript:history.back()"
      >
        {' '}
        Go Back
      </a>{' '}
      to where you were before
      <br />
      - Try search again in few mintures
    </p>
  </ErrorPage>
)



// WEBPACK FOOTER //
// ./client/pages/searchOfflinePage.js